import React, {useContext} from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {Link} from 'react-router'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Container from 'react-bootstrap/Container';
import {Card} from 'react-bootstrap';
import AuthContext from '../../../contexts/AuthContext'
import {forgotLoginPassword} from '../../../hooks/usePassword.ts'
import Field from '../../ui/form/Field'
import Loader from '../../ui/loader/Loader'
import AlertCustom from '../../ui/alert/AlertCustom'
import Logo from '../../ui/logos/Logo'

export const LoginFormForgotPassword = () => {
    const {isAuthenticated} = useContext(AuthContext)
    const {state, dispatch, handleChange, handleSubmit} = forgotLoginPassword()

    return (
        <Container fluid>
            <Row style={{height: '100vh'}} className={'align-items-center'}>
                <Col xs={12} md={5} className={'mx-auto'}>
                    <Row className={'mb-2'}>
                        <Col className={'text-center'}>
                            <Logo />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Header className={'bg-primary border-0 text-white font-weight-bold'}>
                                    Mot de passe oublié
                                </Card.Header>
								<Card.Body>
									<AlertCustom
										heading={false}
										variant="success"
										bodyContent={state.message}
										transition={state.isValid}
										dismissible={false}
										classname={'text-center'}
									/>

									<Row>
										<Col xs={12} md={7} className={'mx-auto'}>
											<Form onSubmit={handleSubmit}>
												<Field
													label={'Identifiant'}
													labelRequired={true}
													name={'floristCode'}
													classNames={'mb-3'}
													value={state.credentials.floristCode}
													onChange={handleChange}
													onFocus={() => {
														dispatch({
															type: 'HANDLE_FOCUS',
														})
													}}
													error={state.errorField.floristCode}
												/>

												<Button
													type="submit"
													disabled={isAuthenticated}
													className="btn-primary mb-3">
													{state.isLoading ? (
														<Loader
															variant="white"
															size="sm"
															classname="my-1 mx-3"
														/> // Indique le loading du dispatch 'FETCH_INIT'
													) : (
														'Valider'
													)}
												</Button>
											</Form>
											<Link
												to="../login"
												className="btn-link text-grey-darker d-flex flex-row align-items-center">
												<FontAwesomeIcon
													icon="chevron-left"
													color="var(--grey-darker)"
													className="mr-1"
												/>
												<span>Retour</span>
											</Link>
										</Col>
									</Row>
								</Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}
